import { usePathname } from "next/navigation";

export const useIsApp = () => {
  const pathname = usePathname();
  const isApp = pathname.includes("/app");
  return isApp;
};
